import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import "./RegionForm.css";
// const url = import.meta.env.VITE_BACKEND_URL;
const url = process.env.REACT_APP_BACKEND_URL;

const RegionForm = () => {
  const [name, setName] = useState("");
  const [country, setCountry] = useState("");
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(false);

  const { id } = useParams();
  const navigate = useNavigate();
  const isEdit = !!id;

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const res = await axios.get(`${url}/api/country`);
        setCountries(res.data.data || []);
      } catch (err) {
        alert(err.response?.data?.message || "Failed to fetch countries");
      }
    };
    fetchCountries();
  }, []);

  useEffect(() => {
    if (isEdit) {
      const fetchRegion = async () => {
        try {
          const res = await axios.get(`${url}/api/regions/${id}`);
          const region = res.data.data;
          setName(region.name);
          setCountry(region.country?._id || "");
        } catch (err) {
          alert(err.response?.data?.message || "Failed to fetch region");
          navigate("/regions");
        }
      };
      fetchRegion();
    }
  }, [id, isEdit, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const regionData = { name, country };

      if (isEdit) {
        await axios.put(`${url}/api/regions/${id}`, regionData);
        alert("Region updated successfully");
      } else {
        await axios.post(`${url}/api/regions`, regionData);
        alert("Region added successfully");
      }

      navigate("/regions");
    } catch (err) {
      alert(err.response?.data?.message || "Operation failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="form-container">
      <h2>{isEdit ? "Edit Region" : "Add New Region"}</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Region Name</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label>Country</label>
          <select
            value={country}
            onChange={(e) => setCountry(e.target.value)}
            required
          >
            <option value="">Select Country</option>
            {countries.map((c) => (
              <option key={c._id} value={c._id}>
                {c.name}
              </option>
            ))}
          </select>
        </div>

        <div className="form-actions">
          <button type="submit" disabled={loading}>
            {loading ? "Processing..." : isEdit ? "Update" : "Save"}
          </button>
          <button type="button" onClick={() => navigate("/regions")}>
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default RegionForm;
